
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/basic.md?watch=parent';
    export const toc = [{"id":"zh-cn","depth":2,"title":"zh-CN"},{"id":"en-us","depth":2,"title":"en-US"}];
export const frontmatter = {"title":"Basic","toc":"menu","filename":"docs/x-sdk/demos/x-chat/basic.md","lastUpdated":1754564591000,"description":"基础用法。"};